import {EXTERNAL_PDF} from 'features/intercept-file-download-anchor/model/constants';
import {ECommonMessages} from 'shared/constants/messages';
import {downloadFile, showMessageFromResponse} from 'shared/utils';

/**
 * Загружает PDF-файл по мутированному URL.
 * @param href - URL с параметром type=external_pdf (из ссылки удаляется), по которому должен скачиваться файл.
 */
export const downloadPdf = (href: string) => {
    downloadFile(
        href.replaceAll(`type=${EXTERNAL_PDF}`, ''),
        'file.pdf',
    ).then(data => {
        if (data.status === 200) {
            showMessageFromResponse({
                response: data,
                customMessage: ECommonMessages.UPLOAD_FILE_SUCCESS,
            });
        }
    }).catch(error => {
        showMessageFromResponse({response: error?.response, isError: true});
    });
};
